export interface PROMPT_RES_DATA_INTERFACE {
  /**
   * The combined manuscript returned by the fifth prompt — abstract, body,
   * single reference list and abbreviations. This alone becomes the .docx;
   * the three section fields below are the raw per-step outputs it was built
   * from, kept for debugging.
   */
  manuscript: string;
  introduction: string;
  results: string;
  discussion: string;
}

export const DEFAULT_PROMPT_RES_DATA: PROMPT_RES_DATA_INTERFACE = {
  manuscript: '',
  introduction: '',
  results: '',
  discussion: '',
} as const;
